
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { AuthLayout } from '@/components/auth/components/AuthLayout';

const EmailVerification = () => {
  return (
    <AuthLayout>
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Verifying Your Email</CardTitle>
          <CardDescription>
            Please wait while we verify your email address...
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center p-6">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </CardContent>
      </Card>
    </AuthLayout>
  );
};

export default EmailVerification;
